export default [
	{
		"level": "Silver",
		"full_name": "Jan Kaluza",
		"thumb_url": "JanKaluza-thumb.jpeg",
		"url": "https://www.patreon.com/user?u=3175485"
	},
	{
		"level": "Bronze",
		"full_name": "Bruno Afonseca",
		"thumb_url": "BrunoAfonseca-thumb.jpeg",
		"url": "https://www.patreon.com/3dbruno"
	},
	{
		"level": "Silver",
		"full_name": "Åke",
		"thumb_url": "Åke-thumb.jpeg",
		"url": "https://www.patreon.com/user?u=134965"
	},
	{
		"level": "Silver",
		"full_name": "Matt Wylliamson",
		"thumb_url": "MattWylliamson-thumb.jpeg",
		"url": "https://www.patreon.com/mattwyll"
	},
	{
		"level": "Silver",
		"full_name": "Martin Říha",
		"thumb_url": "MartinŘíha-thumb.jpeg",
		"url": "https://www.patreon.com/user?u=3638766"
	},
	{
		"level": "Silver",
		"full_name": "Michael Russell",
		"thumb_url": "MichaelRussell-thumb.jpeg",
		"url": "https://www.patreon.com/romsteady"
	},
	{
		"level": "Top supporter",
		"full_name": "Merek Davis",
		"thumb_url": "MerekDavis-thumb.jpeg",
		"url": "https://www.patreon.com/user?u=6191561"
	},
	{
		"level": "Bronze",
		"full_name": "Vagner Diniz",
		"thumb_url": "VagnerDiniz-thumb.jpeg",
		"url": "https://www.patreon.com/user?u=6605389"
	},
	{
		"level": "Silver",
		"full_name": "HDRI Haven",
		"thumb_url": "HDRIHaven-thumb.jpeg",
		"url": "https://www.patreon.com/hdrihaven"
	},
	{
		"level": "Silver",
		"full_name": "Alex",
		"thumb_url": "Alex-thumb.jpeg",
		"url": "https://www.patreon.com/user?u=915584"
	},
	{
		"level": "Silver",
		"full_name": "Mukesh Singh",
		"thumb_url": "MukeshSingh-thumb.jpeg",
		"url": "https://www.patreon.com/singhs_apps"
	}
]


// WEBPACK FOOTER //
// ./src/data/patreonMembers.js